import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { ShipperProfile } from '../../core/shipper-profile/ShipperProfile';

export function ShipperProfileScreen() {
  const { guid = '' } = useParams();
  const [{ open_rating_dialog }] = useQuery();

  if (open_rating_dialog) {
    return <Navigate to={`/rate-shipper/${guid}${window.location.search}`} />;
  }

  return (
    <WebviewLayout>
      <ShipperProfile guid={guid} />
    </WebviewLayout>
  );
}
